<template>

  <!-- @todo - The menu needs to be an include file so its repeated on all pages -->
  <div class="bg-gray-50">

    <!-- menu component -->
    <menu-public></menu-public>
    
    <div class="container card hoverable p-2">
      <div class="text-center d-flex h-100">
        <div class="first-content align-self-center p-3">
          <h3 class="card-title">Subscriptions Dashboard</h3>
        </div>
      </div>

      <h4>Creating Plans - Products</h4>
      <form @submit.prevent="upload" class="bg-light p-4 card mb-4">
        <div class="col-sm-12">
          <div class="alert alert-primary" role="alert">
            What are you gonna do?
          </div>

          <input type="radio" value="0" v-model="product.prod" /> Create Product
          for Single Charge
          <input type="radio" value="1" v-model="product.prod" /> Create Plan for
          Subscription
        </div>

        <div
          class="col-sm-12 mt-2 bg-dark shadow card"
          v-if="product.prod === '0'"
        >
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="inputEmail4"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Name</b
                ></label
              >
              <input
                type="text"
                class="form-control"
                id="inputEmail4"
                v-model="product.name"
                placeholder="Plan reference, Clothes, Software"
              />

              <br />
              <label for="inputAddress"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Rate</b
                ></label
              >
              <input
                type="text"
                class="form-control"
                id="inputEmail4"
                v-model="product.rate"
                placeholder="0.00 US$ / mes"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="exampleFormControlTextarea1"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span>
                  Description</b
                ></label
              >
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                placeholder="A little description for your product"
                v-model="product.description"
                rows="5"
              >
              </textarea>
            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-info btn-sm">Create</button>
          </div>
        </div>

        <div
          class="col-sm-12 mt-2 bg-info shadow card"
          v-else-if="product.prod === '1'"
        >
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="inputEmail4"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Name</b
                ></label
              >
              <input
                type="text"
                class="form-control"
                id="inputEmail4"
                v-model="product.name"
                placeholder="Plan reference, Clothes, Software"
              />

              <br />
              <label for="inputAddress"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Rate</b
                ></label
              >
              <input
                type="text"
                class="form-control"
                id="inputEmail4"
                v-model="product.rate"
                placeholder="0.00 US$ / mes"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="exampleFormControlTextarea1"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span>
                  Description</b
                ></label
              >
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                placeholder="A little description for your product"
                v-model="product.description"
                rows="5"
              >
              </textarea>
            </div>

            <div class="form-group col-md-6">
              <label for="exampleFormControlSelect1"
                ><b class="text-white">
                  <span class="badge badge-pill badge-danger">*</span> Bill
                  Period</b
                ></label
              >
              <select
                v-model="product.period"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <option>Month</option>
                <option>Day</option>
                <option>Week</option>
                <option>3 Months</option>
                <option>6 Months</option>
                <option>Year</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="exampleFormControlFile1"
                ><small class="text-white">
                  <span class="badge badge-pill badge-light">Opcional</span>
                  Image</small
                ></label
              >
              <input
                type="file"
                class="form-control-file"
                id="exampleFormControlFile1"
              />
            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-secondary btn-sm">Create</button>
          </div>
        </div>
      </form>

      <h4>Product List</h4>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Description</th>
              <th>Active</th>
              <th>Created</th>
              <th>Actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="prod in products.data" :key="prod.name">
              <td>{{ prod.id }}</td>
              <td>
                <b> {{ prod.name }} </b>
              </td>
              <td>{{ prod.description }}</td>
              <td>
                <span class="badge badge-pill badge-info">
                  {{ prod.active }}
                </span>
              </td>
              <td>{{ prod.created }}</td>

              <td>
                <a href="#" @click="editPlan(prod)">
                  <i class="fa fa-edit text-success"></i
                  ><span class="text-success">Edit</span>
                </a>
              </td>
              <td>
                <a href="#" @click="deletePlan(prod)">
                  <i class="fa fa-trash text-danger"></i>
                </a>
              </td>
            </tr>

            <!-- Modal -->
            <div
              class="modal fade"
              id="planEdit"
              tabindex="-1"
              role="dialog"
              aria-labelledby="addNewLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog " role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="addNewLabel">
                      Update User Information
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="p-2">
                    <form
                      @submit.prevent="updated(plan)"
                      class="bg-secondary p-4 card mb-4"
                    >
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="inputEmail5"
                            ><b class="text-white">
                              <span class="badge badge-pill badge-danger">*</span>
                              Name</b
                            ></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="inputEmail6"
                            v-model="plan.name"
                            placeholder="Plan reference, Clothes, Software"
                          />
                        </div>

                        <div class="form-group col-md-12">
                          <label for="exampleFormControlTextarea2"
                            ><b class="text-white">
                              <span class="badge badge-pill badge-danger">*</span>
                              Description</b
                            ></label
                          >
                          <textarea
                            class="form-control"
                            id="exampleFormControlTextarea2"
                            v-model="plan.description"
                            rows="5"
                          >
                          </textarea>
                        </div>
                      </div>

                      <div class="form-group text-right">
                        <button type="submit" class="btn btn-success btn-sm">
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- close modal  -->
          </tbody>
        </template>
      </v-simple-table>

      <br />

      <div class="container bg-light">
        <div class="card-deck mb-3 text-center">
          <div
            class="card mb-4 box-shadow"
            v-for="plan in plans.data"
            :key="plan.id"
          >
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">
                {{ plan.metadata.product_name }}
              </h4>
            </div>

            <div class="card-body">
              <h1 class="card-title pricing-card-title">
                {{ dolar(plan.amount) }}<small class="text-muted"> US $</small>
                <small class="text-muted">/ {{ plan.interval }}</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>
                  <p style="white-space: pre-wrap;">
                    {{ plan.metadata.description }}
                  </p>
                </li>
              </ul>
              <button type="button" class="btn btn-lg btn-block btn-dark">
                Purchase
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
export default {
  data() {
    return {
      product: {
        name: "",
        rate: "",
        description: "",
        prod: "",
        period: ""
      },

      plan: "",

      products: [],
      plans: []
    };
  },

  created() {
    this.getProducts();
    this.getPlans();
  },

  methods: {
    upload() {
      window.axios.post("/api/createProduct", this.product).then(res => {
        this.product = [];
        this.getProducts();
        this.getPlans();
        console.log(res.data);
      });
    },

    getPlans() {
      window.axios.get("/api/plans").then(res => {
        this.plans = res.data;
      });
    },

    getProducts() {
      window.axios.get("/api/products").then(res => {
        this.products = res.data;
      });
    },

    editPlan(prod) {
      this.plan = prod;
      $("#planEdit").modal("show");
    },

    updated(plan) {
      window.axios
        .patch("/api/updateProduct/" + plan.id, {
          name: plan.name,
          description: plan.description
        })
        .then(res => {
          this.getProducts();
          console.log(res.data);
        });
    },

    deletePlan(product) {
      alert("Are you sure?");

      window.axios.delete("/api/deleteProduct/" + product.id).then(res => {
        this.getProducts();
        console.log(res.data);
      });
    },

    dolar(value) {
      return value / 100;
    }
  }
};
</script>
<style>
@import "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
</style>
